import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../../../../components/common/GridLayout';
import ColorButton from '../../../../components/common/ColorButton';
import { useActiveStateSelector } from '../../../../containers/customizer.duck';

const VisorColor = ({
  options,
  initialSelectedCustomizationIndex,
  updatePartsConfig,
  partsConfig,
  selectedPart
}) => {
  // const [activeVisorColor, setActiveVisorColor] = useState(
  //   initialSelectedCustomizationIndex
  // );

  // useActiveStateSelector(
  //   'visorColor',
  //   options,
  //   partsConfig,
  //   setActiveVisorColor
  // );
  // useEffect(() => {
  //   setActiveVisorColor(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);

  return (
    <GridLayout columns={2}>
      {options.map((option, i) => (
        <div className="visor-color_item">
          <ColorButton
            isSelected={selectedPart === option.partId}
            text={option.configData.label}
            color={option.configData.hex}
            onClick={() => {
              // setActiveVisorColor(i);
              updatePartsConfig(options[i]);
            }}
          />
        </div>
      ))}
    </GridLayout>
  );
};

VisorColor.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object
};

export default VisorColor;
